export { default } from './CMSPage';
